/**
 * @fileoverview gRPC-Web generated client stub for pbs
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var common_pb = require('./common_pb.js')

var major_pb = require('./major_pb.js')
const proto = {};
proto.pbs = require('./class_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.pbs.ClassServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.pbs.ClassServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pbs.Class,
 *   !proto.pbs.Empty>}
 */
const methodDescriptor_ClassService_Create = new grpc.web.MethodDescriptor(
  '/pbs.ClassService/Create',
  grpc.web.MethodType.UNARY,
  proto.pbs.Class,
  common_pb.Empty,
  /**
   * @param {!proto.pbs.Class} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  common_pb.Empty.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.pbs.Class,
 *   !proto.pbs.Empty>}
 */
const methodInfo_ClassService_Create = new grpc.web.AbstractClientBase.MethodInfo(
  common_pb.Empty,
  /**
   * @param {!proto.pbs.Class} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.pbs.Class} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.pbs.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pbs.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pbs.ClassServiceClient.prototype.create =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pbs.ClassService/Create',
      request,
      metadata || {},
      methodDescriptor_ClassService_Create,
      callback);
};


/**
 * @param {!proto.pbs.Class} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pbs.Empty>}
 *     A native promise that resolves to the response
 */
proto.pbs.ClassServicePromiseClient.prototype.create =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pbs.ClassService/Create',
      request,
      metadata || {},
      methodDescriptor_ClassService_Create);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pbs.Class,
 *   !proto.pbs.Empty>}
 */
const methodDescriptor_ClassService_Update = new grpc.web.MethodDescriptor(
  '/pbs.ClassService/Update',
  grpc.web.MethodType.UNARY,
  proto.pbs.Class,
  common_pb.Empty,
  /**
   * @param {!proto.pbs.Class} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  common_pb.Empty.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.pbs.Class,
 *   !proto.pbs.Empty>}
 */
const methodInfo_ClassService_Update = new grpc.web.AbstractClientBase.MethodInfo(
  common_pb.Empty,
  /**
   * @param {!proto.pbs.Class} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.pbs.Class} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.pbs.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pbs.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pbs.ClassServiceClient.prototype.update =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pbs.ClassService/Update',
      request,
      metadata || {},
      methodDescriptor_ClassService_Update,
      callback);
};


/**
 * @param {!proto.pbs.Class} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pbs.Empty>}
 *     A native promise that resolves to the response
 */
proto.pbs.ClassServicePromiseClient.prototype.update =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pbs.ClassService/Update',
      request,
      metadata || {},
      methodDescriptor_ClassService_Update);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pbs.ClassId,
 *   !proto.pbs.Empty>}
 */
const methodDescriptor_ClassService_Delete = new grpc.web.MethodDescriptor(
  '/pbs.ClassService/Delete',
  grpc.web.MethodType.UNARY,
  proto.pbs.ClassId,
  common_pb.Empty,
  /**
   * @param {!proto.pbs.ClassId} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  common_pb.Empty.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.pbs.ClassId,
 *   !proto.pbs.Empty>}
 */
const methodInfo_ClassService_Delete = new grpc.web.AbstractClientBase.MethodInfo(
  common_pb.Empty,
  /**
   * @param {!proto.pbs.ClassId} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  common_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.pbs.ClassId} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.pbs.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pbs.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pbs.ClassServiceClient.prototype.delete =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pbs.ClassService/Delete',
      request,
      metadata || {},
      methodDescriptor_ClassService_Delete,
      callback);
};


/**
 * @param {!proto.pbs.ClassId} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pbs.Empty>}
 *     A native promise that resolves to the response
 */
proto.pbs.ClassServicePromiseClient.prototype.delete =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pbs.ClassService/Delete',
      request,
      metadata || {},
      methodDescriptor_ClassService_Delete);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pbs.ClassListReq,
 *   !proto.pbs.Classes>}
 */
const methodDescriptor_ClassService_List = new grpc.web.MethodDescriptor(
  '/pbs.ClassService/List',
  grpc.web.MethodType.UNARY,
  proto.pbs.ClassListReq,
  proto.pbs.Classes,
  /**
   * @param {!proto.pbs.ClassListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.pbs.Classes.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.pbs.ClassListReq,
 *   !proto.pbs.Classes>}
 */
const methodInfo_ClassService_List = new grpc.web.AbstractClientBase.MethodInfo(
  proto.pbs.Classes,
  /**
   * @param {!proto.pbs.ClassListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.pbs.Classes.deserializeBinary
);


/**
 * @param {!proto.pbs.ClassListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.pbs.Classes)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pbs.Classes>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pbs.ClassServiceClient.prototype.list =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pbs.ClassService/List',
      request,
      metadata || {},
      methodDescriptor_ClassService_List,
      callback);
};


/**
 * @param {!proto.pbs.ClassListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pbs.Classes>}
 *     A native promise that resolves to the response
 */
proto.pbs.ClassServicePromiseClient.prototype.list =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pbs.ClassService/List',
      request,
      metadata || {},
      methodDescriptor_ClassService_List);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pbs.Ids,
 *   !proto.pbs.Classes>}
 */
const methodDescriptor_ClassService_GetClassesByMajorIds = new grpc.web.MethodDescriptor(
  '/pbs.ClassService/GetClassesByMajorIds',
  grpc.web.MethodType.UNARY,
  common_pb.Ids,
  proto.pbs.Classes,
  /**
   * @param {!proto.pbs.Ids} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.pbs.Classes.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.pbs.Ids,
 *   !proto.pbs.Classes>}
 */
const methodInfo_ClassService_GetClassesByMajorIds = new grpc.web.AbstractClientBase.MethodInfo(
  proto.pbs.Classes,
  /**
   * @param {!proto.pbs.Ids} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.pbs.Classes.deserializeBinary
);


/**
 * @param {!proto.pbs.Ids} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.pbs.Classes)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pbs.Classes>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pbs.ClassServiceClient.prototype.getClassesByMajorIds =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pbs.ClassService/GetClassesByMajorIds',
      request,
      metadata || {},
      methodDescriptor_ClassService_GetClassesByMajorIds,
      callback);
};


/**
 * @param {!proto.pbs.Ids} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pbs.Classes>}
 *     A native promise that resolves to the response
 */
proto.pbs.ClassServicePromiseClient.prototype.getClassesByMajorIds =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pbs.ClassService/GetClassesByMajorIds',
      request,
      metadata || {},
      methodDescriptor_ClassService_GetClassesByMajorIds);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pbs.MyClassListReq,
 *   !proto.pbs.Classes>}
 */
const methodDescriptor_ClassService_MyClassList = new grpc.web.MethodDescriptor(
  '/pbs.ClassService/MyClassList',
  grpc.web.MethodType.UNARY,
  proto.pbs.MyClassListReq,
  proto.pbs.Classes,
  /**
   * @param {!proto.pbs.MyClassListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.pbs.Classes.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.pbs.MyClassListReq,
 *   !proto.pbs.Classes>}
 */
const methodInfo_ClassService_MyClassList = new grpc.web.AbstractClientBase.MethodInfo(
  proto.pbs.Classes,
  /**
   * @param {!proto.pbs.MyClassListReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.pbs.Classes.deserializeBinary
);


/**
 * @param {!proto.pbs.MyClassListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.pbs.Classes)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pbs.Classes>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pbs.ClassServiceClient.prototype.myClassList =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pbs.ClassService/MyClassList',
      request,
      metadata || {},
      methodDescriptor_ClassService_MyClassList,
      callback);
};


/**
 * @param {!proto.pbs.MyClassListReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pbs.Classes>}
 *     A native promise that resolves to the response
 */
proto.pbs.ClassServicePromiseClient.prototype.myClassList =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pbs.ClassService/MyClassList',
      request,
      metadata || {},
      methodDescriptor_ClassService_MyClassList);
};


module.exports = proto.pbs;

